import { j as s } from "./atoms-v218.js";
import { forwardRef as m } from "react";
import { SkeletonRow as n } from "./atoms-v21023.js";
const d = m(
  ({ children: o, className: e = "", height: t = 11, id: r, width: i = "100%" }, a) => /* @__PURE__ */ s.jsx(
    n,
    {
      $height: t,
      $width: i,
      "aria-hidden": "true",
      className: e,
      "data-testid": "skeleton-row",
      id: r,
      ref: a,
      children: o
    }
  )
);
d.displayName = "SkeletonRow";
export {
  d as SkeletonRow
};
